import { UPDATE } from 'react-admin';

export const USERS_ACTIVATE_DEACTIVATE = 'USERS_ACTIVATE_DEACTIVATE';
export const userActivateDeactivate = (id, data) => ({
  type: USERS_ACTIVATE_DEACTIVATE,
  payload: { id, data: { is_active: data.is_active ? 0 : 1 } },
  meta: { fetch: UPDATE, resource: 'users', refresh: true },
});



// WEBPACK FOOTER //
// ./src/resources/users/userReduxActions.js